import HBox from '../layout/HBox';
import styles from './CampoCheckbox.module.css';
import { Checkbox } from '@base-ui/react/checkbox';

type Props = {
  label?: string;
  text: string;
  value: boolean;
  onChange: (value: boolean) => void;
  hint?: string;
  disabled?: boolean;
};

const CampoCheckbox = ({
  label,
  text,
  value,
  onChange,
  hint,
  disabled,
  ...props
}: Readonly<Props>) => {
  return (
    <div className={styles.container}>
      {label && <span className={styles.label}>{label}</span>}
      <label>
        <HBox>
          <Checkbox.Root
            {...props}
            disabled={disabled}
            className={styles.input}
            checked={value ?? false}
            onCheckedChange={(checked) => onChange(checked === true)}
          />
          <span className={disabled ? styles.disabledText : undefined}>
            {text}
          </span>
        </HBox>
      </label>
      {hint && <div className={styles.hint}>{hint}</div>}
    </div>
  );
};

export default CampoCheckbox;
